@if (isLoading) {
  <div class="spinner-container">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
} @else if (orderItem) {

    <div class="user-review-container">
        <div class="top-container">
            <div class="left-section">
                <div class="icon-container" (click)="goBack()">
                    <mat-icon svgIcon="arrowleft" class="back-icon"></mat-icon>
                </div>

                <div class="title-container">
                    <p class="title font-poppins">Write a Review</p>
                    <p class="subtitle">
                        <span class="status">{{orderItem.itemStatus}}</span>
                        <span class="created-at">
                            <mat-icon [svgIcon]="'date'" class="date-icon"></mat-icon>
                            Ordered : {{ getDeliveryDate() | date:'MMM dd, yyyy' }}
                        </span>
                    </p>
                </div>
            </div>

            <div class="right-section">
                <p class="orderid-label">Order ID</p>
                <p class="order-id font-poppins">#{{ orderId }}</p>
            </div>
        </div>

        <div class="bottom-container">
            <div class="item-section">
                <div class="image-container product-image-gradient1">
                    <img [src]="orderItem.product?.images?.imagesUrl?.[0]" alt="Product Image" class="product-image">
                </div>

                <div class="item-details">
                    <p class="item-name font-poppins" appEllipsis maxWidth="700px">{{ orderItem.product?.name }}</p>
                    <p class="item-description" appEllipsis maxWidth="700px" [lines]="2">₹{{ orderItem.product?.description }}</p>
                    <p class="status-container">
                        <span class="status">
                            <span class="icon-container">
                                <mat-icon [svgIcon]="'tick'" class="icon"></mat-icon>
                            </span>
                            <span>{{orderItem.itemStatus}}</span>
                        </span>

                        <span class="order-id">
                            <span class="label">Order ID: </span> <span class="value">#{{orderId}}</span>
                        </span>

                        <span class="deliver-on">
                            <span class="label">Delivered On: </span> <span class="value">{{orderItem.updatedAt | date:'MMM dd, yyyy'}}</span>
                        </span>
                    </p>
                </div>
            </div>

            <form class="form-section" [formGroup]="ratingAndReview">
                <div class="section">
                    <label for="rating" class="label font-poppins">Rate this product</label>
                    <div class="star-container">
                        @for (star of stars;let i = $index; track i) {
                            <mat-icon
                                class="star-icon"
                                [class.selected]="i < ratingAndReview.get('rating')?.value"
                                (click)="selectRating(i + 1)"
                                [svgIcon]="'fullstar'"
                            >
                            </mat-icon>
                        }
                    </div>
                    <p class="text">Tap a star to rate your experience</p>
                </div>

                <div class="section">
                    <label for="rating" class="label font-poppins">Upload image</label>
                    <div class="upload-image-container">
                        <span class="icon-container" (click)="fileInput.click()">
                            <mat-icon svgIcon="upload"></mat-icon>
                        </span>
                        <input
                            class="image-input"
                            #fileInput
                            type="file"
                            id="images"
                            multiple
                            accept="image/jpeg, image/png, image/webp, image/gif"
                            (change)="onFileSelected($event)"
                            [disabled]="images.imagesUrl.length >= 5"
                        />
                        <span class="upload-text">Upload Images</span>
                        <span class="text optional">Optional - Add photos of your product</span>
                        <span class="support-text">Support any format up to 5mb</span>
                    </div>
                </div>

                <div class="preview" *ngIf="images.imagesUrl.length > 0">
                    @for (img of images.imagesUrl;let i = $index;track i) {
                        <div class="preview-image">
                            <img class="upload-image" [src]="img" [alt]="'Image ' + (i + 1)" />
                            <mat-icon class="remove-icon" (click)="removeImage(i)">delete</mat-icon>
                        </div>
                    }
                </div>

                <div class="section">
                    <label for="rating" class="label font-poppins">Write your review</label>
                    <mat-form-field class="example-full-width input-border-radius" appearance="outline">
                        <textarea matInput placeholder="Share your experience with this product" 
                            id="review"
                            rows="8"
                            formControlName="review"
                        >
                        </textarea>
                    </mat-form-field>
                    <p class="text">Your review helps other parents make better choices.</p>
                </div>

                <div class="action-container">
                    <button mat-flat-button (click)="goBack()" class="btn btn-secondary-gradient">Cancel</button>

                    <button mat-flat-button (click)="goBack()" class="btn btn-primary-gradient" (click)="submitReview()" [disabled]="ratingAndReview.invalid">Submit Review</button>
                </div>
            </form>
        </div>

    </div>

} @else {
  <div class="no-order-container">
    <app-no-order-item></app-no-order-item>
  </div>
}
